import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
  Avatar,
  Card,
  CardContent
} from '@mui/material';
import { LockOutlined, AdminPanelSettings } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const LoginTest = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({
    email: 'admin@teste.com',
    password: 'admin123'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Se já estiver autenticado, redirecionar para dashboard
  if (isAuthenticated) {
    navigate('/dashboard');
    return null;
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(formData);

      if (result.success) {
        navigate('/dashboard');
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Erro inesperado. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleQuickLogin = (email, password) => {
    setFormData({ email, password });
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <LockOutlined />
          </Avatar>

          <Typography component="h1" variant="h4" sx={{ mb: 3 }}>
            Sistema de Inventário
          </Typography>

          <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
            Teste de Login
          </Typography>

          {/* Botões de login rápido */}
          <Card sx={{ mb: 3, width: '100%' }}>
            <CardContent>
              <Typography variant="subtitle2" gutterBottom>
                Login Rápido:
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<AdminPanelSettings />}
                  onClick={() => handleQuickLogin('admin@teste.com', 'admin123')}
                >
                  Admin Teste
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleQuickLogin('admin@exemplo.com', 'admin123')}
                >
                  Admin Exemplo
                </Button>
              </Box>
            </CardContent>
          </Card>

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              type="email"
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Senha"
              type="password"
              id="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </Box>

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Sistema de Gestão de Inventário v1.0
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Backend: http://localhost:3001 | Frontend: http://localhost:5174
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginTest;
